"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Pagination = _interopRequireDefault(require("@mui/material/Pagination"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _OutlinedInput = _interopRequireDefault(require("@mui/material/OutlinedInput"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _StyledPaginationPublisherModule = _interopRequireDefault(require("./StyledPaginationPublisher.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const defaultItemsPerPageOptions = [12, 24, 36];

/**
 *
 * @param {(pagination: {offset: number; limit?: number}) => void} props.handleChange
 * @returns
 */
const StyledPaginationPublisher = _ref => {
  let {
    limit,
    offset,
    total_count,
    handleChange,
    itemsPerPageOptions,
    variant
  } = _ref;
  const itemsPerPageProps = itemsPerPageOptions ?? defaultItemsPerPageOptions;
  const [itemsPerPage, setItemsPerPage] = (0, _react.useState)(limit);
  const getPaginationPropsForVariant = (0, _react.useCallback)(() => {
    switch (variant) {
      case "variant2":
        {
          return {
            color: "primary",
            shape: "rounded",
            size: "small",
            sx: {
              "& .MuiPaginationItem-root": {
                fontSize: "0.875rem"
              }
            }
          };
        }
      default:
        {
          return undefined;
        }
    }
  }, [variant]);
  const getPageByOffset = offset => {
    return Math.floor(offset / limit) + 1;
  };
  const getOffsetByPage = page => {
    return (page - 1) * limit;
  };
  const handleItemsPerPagePublisher = event => {
    const pagination = {
      offset: 0,
      limit: Number(event.target.value)
    };
    setItemsPerPage(Number(event.target.value));
    handleChange(pagination);
  };
  const handlePageChangePublisher = page => {
    if (page === getPageByOffset(offset)) {
      return;
    }
    const pagination = {
      offset: getOffsetByPage(page)
    };
    handleChange(pagination);
  };
  const startElement = offset + 1;
  const endElement = Math.min(limit + offset, total_count);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _StyledPaginationPublisherModule.default.paginationContainerPublisher
  }, /*#__PURE__*/_react.default.createElement(_Pagination.default, _extends({
    count: Math.ceil(total_count / limit),
    onChange: (_e, page) => handlePageChangePublisher(page),
    className: _StyledPaginationPublisherModule.default.styledPaginationPublisher,
    page: getPageByOffset(offset)
  }, getPaginationPropsForVariant())), /*#__PURE__*/_react.default.createElement("div", {
    className: _StyledPaginationPublisherModule.default.pageCountSectionPublisher
  }, /*#__PURE__*/_react.default.createElement("span", null, "Items per page"), /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    variant: "outlined",
    className: _StyledPaginationPublisherModule.default.pageListformControlPublisher
  }, /*#__PURE__*/_react.default.createElement(_Select.default, {
    value: itemsPerPage,
    input: /*#__PURE__*/_react.default.createElement(_OutlinedInput.default, {
      name: "age",
      id: "outlined-age-simple",
      onChange: handleItemsPerPagePublisher
    }),
    MenuProps: {
      disablePortal: false,
      container: () => document.body,
      disableScrollLock: true
    }
  }, itemsPerPageProps.map(items => /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    key: items,
    value: items
  }, items)))), /*#__PURE__*/_react.default.createElement("span", null, startElement === endElement ? startElement : `${startElement}-${endElement}`, " ", "of ", total_count)));
};
var _default = exports.default = StyledPaginationPublisher;